module.exports = __webpack_public_path__ + "media/images/icons/outlined/play-circle-dce6c5212eddfb47ba0948284925aef7.svg";